/**
 * Renderiza y compila la toolbar, primero esperando las traducciones
 * @param {ibject} scope
 * @param {HTMLElement} elem
 * @param {object} locale
 * @param {function} $compile
 */
export function templateFn(scope, elem, locale, $compile, tree) {
  const eInsertBtns = generateInsertBtns(tree, locale);

  elem.innerHTML = `
    <div ng-init="isFullscreen=false" ec-fullscreen="isFullscreen" ng-form="fbTreeForm">

      <div ec-overlay="light" action="create" ec-center ec-text-align="center" tabindex="0">
        <ewc-icon name="plus"></ewc-icon>
        <label>${locale['fbTree.create']} ${tree[0].title || ''}</label>
      </div>

      <div class="fb-tree--left">
        <div ec-layout>
          <ec-toolbar responsive class="fb-tree--toolbar-tree">
            <ec-group>
              ${eInsertBtns}
              <ec-button class="js-fb-tree--btn--duplicate" disabled action="duplicate" icon="clone" label="${locale['fbTree.clone']}"></ec-button>
              <ec-button class="js-fb-tree--btn--remove" disabled action="remove" icon="circle-xmark" ec-danger="basic" label="${locale['fbTree.remove']}"></ec-button>
            </ec-group>
          </ec-toolbar>
          <main>
            <ewc-tree fill></ewc-tree>
            <ec-button action="create" icon="plus" label="${locale['fbTree.add']} ${tree[0].title || ''}"></ec-button>
          </main>
        </div>
      </div>

      <div class="fb-tree--right">
        <div ec-layout ec-responsive>
          <ec-toolbar responsive>
            <ec-space></ec-space>
            <ec-button ng-show="isFullscreen" icon="down-left-and-up-right-to-center" click="isFullscreen=false"></ec-button>
            <ec-button ng-show="!isFullscreen" icon="up-right-and-down-left-from-center" click="isFullscreen=true"></ec-button>
          </ec-toolbar>
          <main class="fb-tree--form"></main>
        </div>
      </div>

    </div>`;
  // $compile(angular.element(elem.querySelector('.fb-tree--left ec-toolbar')))(scope);
  // $compile(angular.element(elem.querySelector('.fb-tree--right ec-toolbar')))(scope);
  $compile(angular.element(angular.element(elem).contents()))(scope);
}

/**
 * Devuelve el html de los botones INSERT.
 * Se pinta un botón por nodo para meter le la información de que nodos hijos se le puede insertar.
 *
 * @param {object[]} tree los nodos del arbol
 * @param {object} locale las traducciones
 * @return {string}
 */
function generateInsertBtns(tree, locale) {
  // creamos un boton disabled primero, que se mostrara cuando ningún otro toca
  return `<ec-button class="js-fb-tree--btn--insert" disabled icon="plus" label="${locale['fbTree.insert']}"></ec-button>
  ${handleNodes(tree, locale)}`;
}

function handleNodes(nodes, locale) {
  return nodes
    .map(node => {
      if (!node.children || node.children === 0) {
        // si no tiene hijos, pintamos un boton desabilitado
        return `<ec-button class="js-fb-tree--btn--insert" disabled icon="plus" label="${locale['fbTree.insert']}" hidden node="${node.model}"></ec-button>`;
      }
      if (node.children.length === 1) {
        return `<ec-button class="js-fb-tree--btn--insert" action="insert" icon="plus" label="${locale['fbTree.insert']}" hidden node="${node.model}" child="${
          node.children[0].model
        }"></ec-button>
          ${handleNodes(node.children, locale)}`;
      }
      return `<ec-button role="menu" class="js-fb-tree--btn--insert" icon="plus" label="${locale['fbTree.insert']}" hidden node="${node.model}">
          ${node.children
            .map(child => {
              return `<ec-button action="insert" icon="plus" label="${locale['fbTree.insert']} ${child.title || ''}" node="${node.model}" child="${child.model}"></ec-button>
              `;
            })
            .join('')}
          </ec-button>
          ${handleNodes(node.children, locale)}`;
    })
    .join('');
}
